import { useEffect, useRef } from 'react';
import { logout } from '../http/user';
import { useSelector } from 'react-redux';

const DEFAULT_SESSION_TIMEOUT = parseInt(process.env.REACT_APP_DEFAULT_SESSION_TIMEOUT);

export const useSessionTimeout = (
  dispatch,
  setSessionExpiredOpen,
  setSignInOpen,
  setSignUpOpen
) => {
  const logoutTimer = useRef(null);
  const sessionStart = useSelector((state) => state.user.sessionStart);

  const clearLogoutTimer = () => {
    if (logoutTimer.current) {
      clearTimeout(logoutTimer.current);
      logoutTimer.current = null;
    }
  };

  const manualExit = () => {
    clearLogoutTimer();
    dispatch({ type: 'User/UPDATE', payload: { sessionStart: null } });
    dispatch(logout());
  };

  const handleSessionExpired = () => {
    clearLogoutTimer();
    dispatch({ type: 'User/UPDATE', payload: { sessionStart: null } });
    dispatch(logout());
    setSessionExpiredOpen(true);
    setSignInOpen(false);
    setSignUpOpen(false);
  };

  const startLogoutTimer = () => {
    const now = Date.now();

    dispatch({ type: 'User/UPDATE', payload: { sessionStart: now } });

    clearLogoutTimer();

    logoutTimer.current = setTimeout(() => {
      handleSessionExpired();
    }, DEFAULT_SESSION_TIMEOUT);
  };

  const closeSessionExpiredModal = () => {
    setSessionExpiredOpen(false);
    setSignInOpen(true);
  };

  useEffect(() => {
    if (sessionStart) {
      const elapsed = Date.now() - sessionStart;
      const remainingTime = DEFAULT_SESSION_TIMEOUT - elapsed;

      if (remainingTime <= 0) {
        handleSessionExpired();
      } else {
        clearLogoutTimer();
        logoutTimer.current = setTimeout(handleSessionExpired, remainingTime);
      }
    }

    return clearLogoutTimer;
  }, [sessionStart]);

  return {
    startLogoutTimer,
    clearLogoutTimer,
    closeSessionExpiredModal,
    manualExit
  };
};
